import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import DeleteAccountConfirmationDialog from '@/pages/delete-account-confirmation-dialog';

interface UserProfileMenuProps {
  open: boolean;
  onClose: () => void;
}

export function UserProfileMenu({ open, onClose }: UserProfileMenuProps) {
  const { user, logoutMutation, deleteAccountMutation } = useAuth();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  if (!open) return null;

  const handleLogout = () => {
    logoutMutation.mutate();
    onClose();
  };

  const handleDeleteAccount = () => {
    setShowDeleteDialog(true);
  };

  const confirmDeleteAccount = () => {
    deleteAccountMutation.mutate();
    setShowDeleteDialog(false);
    onClose();
  };

  const cancelDeleteAccount = () => {
    setShowDeleteDialog(false);
  };
  
  // The menu items for navigation
  const navigationItems = [
    // {
    //   title: "Dashboard",
    //   href: "/",
    // },
    {
      title: "Documents",
      href: "/documents",
    },
    {
      title: "Payments",
      href: "/payments",
    },
    {
      title: "Obi AI", 
      href: "/ai-chat",
    },
  ];
  
  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 flex justify-center items-start overflow-auto"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-b-lg overflow-hidden animate-in fade-in-0 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-[#4c7375] p-4 text-white flex items-center justify-between">
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-primary flex items-center justify-center mr-3 text-xl font-bold">
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </div>
            <div>
              <h3 className="font-medium">{user?.firstName} {user?.lastName}</h3>
              <p className="text-xs opacity-90">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Close menu"
            className="text-white hover:bg-white/10 rounded-full p-1"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="py-2">
          {/* {navigationItems.map((item) => (
            <Link 
              key={item.href} 
              href={item.href}
              onClick={onClose}
            >
              <div className="px-4 py-3 hover:bg-gray-100 cursor-pointer">
                <span className="text-gray-800 font-medium">{item.title}</span>
              </div>
            </Link>
          ))}
          
          <Link href="/settings" onClick={onClose}>
            <div className="px-4 py-3 hover:bg-gray-100 cursor-pointer">
              <span className="text-gray-800 font-medium">Account Settings</span>
            </div>
          </Link> */}
          
          <div 
            className="px-4 py-3 hover:bg-red-50 cursor-pointer text-red-600"
            onClick={handleLogout}
          >
            <span className="font-medium">Log out</span>
          </div>

          <div 
            className="px-4 py-3 hover:bg-red-50 cursor-pointer text-red-600"
            onClick={handleDeleteAccount}
          >
            <span className="font-medium">Delete my account</span>
          </div>
        </div>

        <DeleteAccountConfirmationDialog
          isOpen={showDeleteDialog}
          onConfirm={confirmDeleteAccount}
          onCancel={cancelDeleteAccount}
        />
      </div>
    </div>
  );
}